<template>
    <div class="row">
        <div class="section">
            <div class="container">
                <div class="slider">
                    <ul class="slides">
                        <li>
                            <img src="../../img/galeriaFotos/048.jpg"> <!-- random image -->
                        </li>
                        <li>
                            <img src="../../img/galeriaFotos/054-1.jpg"> <!-- random image -->
                        </li>
                        <li>
                            <img src="../../img/galeriaFotos/041.jpg"> <!-- random image -->
                        </li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col s12 m12 l12">
                        <div class="card z-depth-2 hoverable">
                            <div class="card-content">
                                <span class="card-title">O Hotel</span>
                                <p>O <b>Resplendor Center Hotel</b> está localizado no coração da
                                    cidade de Resplendor MG, próximo dos centros comerciais e
                                    restaurantes. Proporcionando um lugar para trabalhar e relaxar!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">

    export default {
        mounted(){
            $('nav div ul').children().removeClass('active');
            $('.nav-hotel').addClass('active');

            $('.slider').slider();
            $('.materialboxed').materialbox();
        }
    };
</script>


// WEBPACK FOOTER //
// hotel.vue?ed9dc030